import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const LANGS = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
];

export default function LanguageSwitcher({ dark = false }) {
  const { i18n } = useTranslation();
  return (
    <Select value={i18n.language} onValueChange={(v) => i18n.changeLanguage(v)}>
      <SelectTrigger
        data-testid="language-switcher"
        className={`w-[86px] rounded-md border-slate-300 h-9 text-xs font-semibold gap-1 ${
          dark ? "bg-transparent text-white" : "bg-white text-[#0A2540]"
        }`}
      >
        <Globe className="w-3.5 h-3.5" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-white min-w-[86px]">
        {LANGS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-${l.code}`}>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
